import { useMatchMedia } from '@xing-com/crate-hooks-use-match-media';
import { mediaTopBarHidden } from '@xing-com/layout-tokens';

/**
 * @deprecated: This hook doesn't work great with SSR, please use CSS instead if
 * you can.
 *
 * Returns `true` if the viewport size is one where the top bar is usually
 * hidden.
 *
 * **Caveats:**
 *   - It only checks browser window width and does not take into account the
 *     `showOnLargerScreens` prop or any other custom logic to show/hide the
 *     top bar.
 *   - It does not work on the server side, where it always returns `undefined`.
 */
export const useIsTopBarHidden = (): boolean | undefined => {
  const media = mediaTopBarHidden;

  const matches = useMatchMedia(media);

  return matches;
};
